export default __webpack_public_path__ + "17915ff7745da35823602abc8433f913.svg";